import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
`;

const ShimmerWrapper = styled.div<{ width?: string; height?: string; borderRadius?: string }>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '1rem'};
  border-radius: ${({ borderRadius }) => borderRadius || '4px'};
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 100%;
  animation: ${shimmerAnimation} 1.2s infinite linear;
`;

type ShimmerProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
};

export const Shimmer: React.FC<ShimmerProps> = ({ width, height, borderRadius }) => {
  return <ShimmerWrapper width={width} height={height} borderRadius={borderRadius} />;
};
